export const BoUrl = {
  signin: '/apirest/v1/backoffice/auth/signin',
  oidc: '/apirest/v1/backoffice/auth/oidc',
  menu: '/apirest/v1/backoffice/user/menu',
  user: {
    getUser: '/apirest/v1/cash/user/backoffice/search',
    getUserBaseUrl: '/apirest/v1/cash/user/backoffice',
  },
  codeOperation: {
    getCodeOperaton: '/apirest/v1/backoffice/operationcode/search',
    deleteItem: '/apirest/v1/backoffice/operationcode/',
    getItem: '/apirest/v1/backoffice/operationcode/',
    baseUrl: '/apirest/v1/backoffice/operationcode',
  },
  adminGroup: {
    getListe: '/apirest/v1/backoffice/admingroup/search',
    baseUrl: '/apirest/v1/backoffice/admingroup',
  },
  profil: {
    create: '/apirest/v1/backoffice/admingroup',
  },
  userGroup: {
    baseUrl: '/apirest/v1/backoffice/group/',
    getList: '/apirest/v1/backoffice/group/search',
    getFiche: '/apirest/v1/backoffice/group/',
    postData: '/apirest/v1/backoffice/group',
    pass_to_prod: '/apirest/v1/backoffice/group/',
    administer: {
      getList: '/apirest/v1/backoffice/group/',
      getListControlRemise: 'apirest/v1/backoffice/group/remittance/search',
    },
    initialiser: {
      getFiliale: '/apirest/v1/backoffice/group/initialization/group/',
      initialisationGroup: '/apirest/v1/backoffice/group/initialization',
      importFile: '/apirest/v1/backoffice/group/initialization/import/',
      importCubicus: '/apirest/v1/backoffice/group/import/cubicus',
      importFileBenef:
        '/apirest/v1/backoffice/group/initialization/beneficiary/import',
      getFormat: '/apirest/v1/backoffice/group/initialization/format/',
      deleteFormat: '/apirest/v1/backoffice/group/initialization/',
      putFormat: '/apirest/v1/backoffice/group/initialization/format/',
      downloadDefaultFile:
        '/apirest/v1/backoffice/group/initialization/import/getfile/',
      deleteScript: 'apirest/v1/backoffice/group/import/cubicus/',
    },
  },
  adminGeneralGroup: {
    lunchGeneral: '/apirest/v1/backoffice/generaladministration/checkbdd',
    controlAcces: '/apirest/v1/backoffice/generaladministration/authorization',
    controleLabel: '/apirest/v1/backoffice/generaladministration/label',
    controleWidget: '/apirest/v1/backoffice/generaladministration/widget',
    controleField: '/apirest/v1/backoffice/generaladministration/table/field',
    ebam: '/apirest/v1/backoffice/generaladministration/ebam',
    getListGroup: '/apirest/v1/backoffice/generaladministration',
    audit: '/apirest/v1/backoffice/group/trace/search',
    getJsonAudit: '/apirest/v1/backoffice/group/trace/',
    lunchJob: '/apirest/v1/backoffice/generaladministration/certificate/hpb',
  },
  loginPageClient: {
    login: '/apirest/v1/backoffice/user/logas/',
    getMenuLogas: '/apirest/v1/backoffice/user/logas/group/',
  },
  currency: {
    getListe: '/apirest/v1/backoffice/currency/search',
    baseUrl: '/apirest/v1/backoffice/currency',
    getFiche: '/apirest/v1/backoffice/currency/',
  },
  pays: {
    liste: '/apirest/v1/backoffice/country/search',
    edit: '/apirest/v1/backoffice/country/',
    create: '/apirest/v1/backoffice/country',
    delete: '/apirest/v1/backoffice/country/',
  },
  home: {
    liste: 'apirest/v1/alert/bo',
  },
  account_releve: {
    liste: '/apirest/v1/backoffice/consultation/',
  },
  list_job: {
    liste: '/apirest/v1/backoffice/consultation/',
  },
}

